export default __webpack_public_path__ + "static/media/img-1.3a51321d.jpg";